import { GpsCoordinateHelper, ReferencePoint, GeneralVector } from "../../libs/CoordinateHelper";
import { MapDefaults, LatLngZoom } from "../../libs/LeafletHelper";
import { ShowTrackModel } from "../../models/tasks/ShowTrackModel";
import { GpsLocationHistory } from "../../entities/GpsLocationHistory";
import { StateParams } from "@uirouter/angularjs";
import { CRS, ImageOverlay, Marker, LatLng, Polyline, Icon } from "leaflet";

export class ShowTrackCtrl {
    assetId:number;
    // Map data
    defaults: MapDefaults = new MapDefaults(false, CRS.Simple, 5, -5);
    center: LatLngZoom = new LatLngZoom(0, 0, 0);
    gpsCoordinateHelper: GpsCoordinateHelper;
    imageLayer: ImageOverlay = null;
    markers: Marker [] = [];
    paths: Polyline [] = [];
    greenIcon : Icon;
    blueIcon : Icon;
    map: any;
    public static $inject = ['$scope', '$stateParams', 'leafletData', 'ShowTrackModel']

    constructor(public $scope:any, public stateParamsService:StateParams, public leafletData: any, public model:ShowTrackModel) {
        $scope.vm = this;
        this.assetId = stateParamsService["id"];
        this.createIcons();
        // Order of operations - query map data for model - get map widget - add data to map widget
        this.model.init(this.assetId).then((ok:boolean) => {
            // Map data
            var mapPromise = leafletData.getMap("mainMap");
            return mapPromise;
        }).then((map) => {
            this.map = map;
            this.model.selectMapArea();
            // Refresh display
            this.setImage();
            this.setPoints();
            this.setPaths();
            this.setWatches();
        });
    }
    // Respond to user selections by refreshing the display
    setWatches() {
        // Number of displayed points changed
        this.$scope.$watch(() => this.model.nDisplayedPoints, (newVal:number, oldVal:number) => {
            if (oldVal != newVal) {
                // Refresh display
                this.setPoints();
                this.setPaths();
            }
        });
        // First displayed point changed
        this.$scope.$watch(() => this.model.itemTimeSeen, (newVal:string, oldVal:string) => {
            if (oldVal != newVal) {
                this.model.updateIndex();
                var bImageChange:boolean = this.model.selectMapArea();
                if (bImageChange) {
                    this.setImage();
                }
                this.setPoints();
                this.setPaths();
            }
        });
    }
    setImage() {
        // Clear existing image
        if (this.imageLayer != null) {
            this.map.removeLayer(this.imageLayer);
        }
        // Add new image
        if (this.model.selectedMapArea == null)
            return;
        this.gpsCoordinateHelper = new GpsCoordinateHelper(
            new ReferencePoint(this.model.selectedMapArea.geo1Longitude, this.model.selectedMapArea.geo1Latitude, 300, this.model.selectedMapArea.geo1PixelsX, this.model.selectedMapArea.geo1PixelsY),
            new ReferencePoint(this.model.selectedMapArea.geo2Longitude, this.model.selectedMapArea.geo2Latitude, 300, this.model.selectedMapArea.geo2PixelsX, this.model.selectedMapArea.geo2PixelsY),
            this.model.selectedMapArea.pixelsPerMeter);
        this.model.getMapAreaImage().then((ok:boolean) => {
            var fdid = this.model.selectedMapArea.fileDataID;
            var height = this.model.selectedMapArea.imageHeight;
            var width = this.model.selectedMapArea.imageWidth;
            var imgUrl = "data:image/png;base64," + this.model.imageData;
            this.imageLayer = new ImageOverlay(imgUrl, [[0, 0], [-1 * height, width]]).addTo(this.map);
            this.imageLayer.bringToBack();
            this.center.lat = -1 * height / 2;
            this.center.lng = width / 2;
            this.center.zoom = 0;
        });
    }
    setPoints() {
        // Clear existing markers
        for (var i = 0; i < this.markers.length; i++) {
            this.map.removeLayer(this.markers[i]);
        }
        this.markers.length = 0;
        // Add new markers
        var numPoints = Math.min(this.model.allGpsLocationHistories.length - this.model.firstDisplayedPoint, this.model.nDisplayedPoints);
        for (var i = this.model.firstDisplayedPoint; i < this.model.firstDisplayedPoint + this.model.nDisplayedPoints; i++) {
            if (i < this.model.allGpsLocationHistories.length) {
                var glh: GpsLocationHistory = this.model.allGpsLocationHistories[i];
                var coords: GeneralVector = this.gpsCoordinateHelper.getTrackPoint(glh.latitude, glh.longitude);
                var d: Date = new Date(glh.timeSeen);
                var info: string = "(#" + (i - this.model.firstDisplayedPoint + 1) + ") " + d.toLocaleString();
                var m: L.Marker = new Marker(new LatLng(coords.Y, coords.X), {title: info });
                if (i == this.model.firstDisplayedPoint) {
                    m.setIcon(this.greenIcon);
                } else {
                    m.setIcon(this.blueIcon);
                }
                m.setZIndexOffset(100 * (numPoints - i));
                this.markers.push(m);
                m.addTo(this.map);
            } else {
                break;
            }
        }
    }
    setPaths() {
        // Clear existing paths
        for (var i = 0; i < this.paths.length; i++) {
            this.map.removeLayer(this.paths[i]);
        }
        this.paths.length = 0;
        // Need at least two points for a path
        var numPoints = Math.min(this.model.allGpsLocationHistories.length - this.model.firstDisplayedPoint, this.model.nDisplayedPoints);
        if (numPoints < 2) {
            return;
        }
        // Add new path
        var segments: L.LatLngExpression[] = [];
        for (var i = this.model.firstDisplayedPoint; i < this.model.firstDisplayedPoint + this.model.nDisplayedPoints; i++) {
            if (i < this.model.allGpsLocationHistories.length) {
                var glh: GpsLocationHistory = this.model.allGpsLocationHistories[i];
                var coords: GeneralVector = this.gpsCoordinateHelper.getTrackPoint(glh.latitude, glh.longitude);
                segments.push(new LatLng(coords.Y, coords.X));
            } else {
                break;
            }
        }
        var p: Polyline = new Polyline(segments, {
            color: '#6DC5FB',
            weight: 3.0,
            opacity: 1.0,
        });
        this.paths.push(p);
        p.addTo(this.map);
    }
    // Green icon for most recent point
    createIcons() {
        this.greenIcon = new Icon({
            iconUrl: 'images/marker-icon-green.png',
            iconRetinaUrl: 'images/marker-icon-2x-green.png',
            iconSize: [25, 41],
            iconAnchor: [12, 41],
            popupAnchor: [1, -34],
            shadowSize: [41, 41]
        });
        this.blueIcon = new Icon({
            iconUrl: 'images/marker-icon-blue.png',
            iconRetinaUrl: 'images/marker-icon-2x-blue.png',
            iconSize: [25, 41],
            iconAnchor: [12, 41],
            popupAnchor: [1, -34],
            shadowSize: [41, 41]
        });
    }
}

